// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.alerts-list-container[data-v-7e7becc0] {\n  list-style-type: none;\n  padding: 0;\n  margin-top: 8px;\n  min-height: 300px;\n}\n.alerts-list-container .divider-line[data-v-7e7becc0] {\n  border-top: 1px solid #dddcdc;\n  margin: 4px 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
